import styled from "styled-components";

const FreteGratisMainContainer = styled.div`
  position: relative;
  width: 100%;
  .dropdown {
    .novo {
      cursor: pointer;
      margin-top: 0;
      text-align: center;
      color: ${(props) => props.theme.colors.primary};
      min-height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export { FreteGratisMainContainer };
